import api from '../../config/axiosConfig';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleAsyncThunk } from '../asyncWrapper';

/*
 * GET @ preventivatore/fornitori
 * response: [fornitori]
 */
export const getFornitori = createAsyncThunk(
  'clienti/getFornitori',
  handleAsyncThunk(async () => {
    const res = await api.get('/preventivatore/fornitori');
    return res.data.data;
  })
);
